import { APIRequest } from '@lynx/client-core/src/api'
import { Sidebar } from 'components/Sidebar'
import { View } from 'components/View'
import React, { ChangeEvent, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ApplicationState } from 'store'
import { ProfileName } from './components/ProfileName'
import { ProfileNameEditor } from './components/ProfileNameEditor'
import css from './Started.module.scss'

export interface StartedProps {
	setShowQr: () => void
	profileInput: string
	profanity: string[]
	accessToken: string
}

export const Started = ({ setShowQr, profanity, accessToken }: StartedProps): React.ReactElement | null => {
	const {
		profile: { displayName, userId },
		session: { ended, isAdmin }
	} = useSelector((state: ApplicationState) => state)
	const navigate = useNavigate()
	const [showProfile, setShowProfile] = useState<boolean>(false)
	const [profileInputState, setProfileInput] = useState<string>(displayName)
	const [name, setName] = useState<string>(displayName)

	const handleNameChange = (): void => {
		setName(profileInputState)
		setShowProfile(!showProfile)
	}

	const handleEditName = (): void => {
		const redirect = encodeURIComponent(`${window.location.pathname}${window.location.search}`)
		navigate(`/auth/login?redirect=${redirect}`)
	}

	const handleNameTextChange = (e: ChangeEvent<HTMLInputElement>): void => {
		const { value: profileInput } = e.target
		setProfileInput(profileInput)
	}

	const isAllowed = (): boolean => {
		return profileInputState.includes('(admin)') || ['unknown', 'anonymous', 'Admin'].includes(profileInputState) || profanity.includes(profileInputState)
	}

	useEffect(() => {
		setProfileInput(displayName)
		setName(displayName)
	}, [userId, displayName])

	useEffect(() => {
		const change = async (): Promise<void> => {
			await APIRequest.Channels.changeDisplayName(name)
		}

		if (!isAllowed || !accessToken) {
			return
		}

		change()
	}, [name])

	if (ended) {
		return null
	}

	return (
		<View>
			{isAdmin && <Sidebar showQr={setShowQr} />}
			<div id="screen" className={css['screen']} />
			{!isAdmin && !showProfile && <ProfileName handleNameChange={handleNameChange} profileInputState={profileInputState} />}
			{!isAdmin && showProfile && (
				<ProfileNameEditor
					handleEditName={handleEditName}
					handleNameTextChange={handleNameTextChange}
					handleNameChange={handleNameChange}
					profileInputState={profileInputState}
				/>
			)}
		</View>
	)
}
